import Oidc from "oidc-client";

var manager = new Oidc.UserManager({
  authority: process.env.VUE_APP_AUTHORITY,
  client_id: process.env.VUE_APP_CLIENT_ID,
  redirect_uri: window.location.origin + "/callback",
  response_type: "code",
  scope: "openid profile offline_access visionops.api IdentityApi.UserManagement",
  post_logout_redirect_uri: window.location.origin + "/signed-out",
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + "/static/silent-renew.html"
});

export default manager;
